// [ai-refactored-code]
import { CustomColumnModelInterface, TableColumnsSetting } from '@/interfaces/table-setting';
import { GaragePassage } from '@/models/garage-passage.model';
import { of } from 'rxjs';

export class GaragePassagesTableSettings {
  public static getColumnsSetting(): TableColumnsSetting<keyof GaragePassage> {
    return [
      this.getCustomColumnDaInviare(),
      this.getCustomColumnDaNonInviare(),
      this.getCustomColumnDetail(),
      {
        name: 'id',
        text: 'ID',
        type: 'number',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'reparto',
        text: 'Reparto',
        filter: {
          type: 'select',
          options: of([{ VENDITE: 'VENDITE' }, { OFFICINA: 'OFFICINA' }]),
        },
      },
      {
        name: 'tipoVendita',
        text: 'Tipo Vendita',
        filter: {
          type: 'select',
          options: of([{ INTERNO: 'INTERNO' }, { ESTERNO: 'ESTERNO' }]),
        },
      },
      {
        name: 'numeroPratica',
        text: 'Numero Pratica',
        type: 'number',
        filter: {
          type: 'number',
        },
      },
      {
        name: 'dataDocumento',
        text: 'Data Documento',
        type: 'date',
        filter: {
          type: 'date',
        },
      },
      {
        name: 'statoRecord',
        text: 'Stato',
        filter: {
          type: 'select',
          options: of([
            { INVIATO: 'INVIATO' },
            { ESCLUSO: 'ESCLUSO' },
            { DA_INVIARE: 'DA INVIARE' },
            { DA_NON_INVIARE: 'DA NON INVIARE' },
            { INVIO_IN_CORSO: 'INVIO IN CORSO' },
            { INVIO_FALLITO: 'INVIO FALLITO' },
          ]),
        },
      },
      {
        name: 'statoConsegnaVgi',
        text: 'Stato Consegna',
        filter: {
          type: 'select',
          options: of([{ INVIATO_VGI: 'INVIATO_VGI' }, { NON_INVIATO_VGI: 'NON_INVIATO_VGI' }]),
        },
      },
      {
        name: 'valid',
        text: 'Valido',
        type: 'checkbox',
        filter: {
          type: 'select',
          options: of([{ true: 'Si' }, { false: 'No' }]),
        },
      },
      {
        name: 'validWhatsapp',
        text: 'Valido Whatsapp',
        type: 'checkbox',
        filter: {
          type: 'select',
          options: of([{ true: 'Si' }, { false: 'No' }]),
        },
      },
      {
        name: 'sentWhatsappDate',
        text: 'Data invio Whatsapp',
        type: 'datetime',
      },
      {
        name: 'marca',
        text: 'Marca',
        filter: {
          type: 'select',
          options: of([{ V: 'V' }, { C: 'C' }, { N: 'N' }]),
        },
      },
      {
        name: 'modelloEmail',
        text: 'Modello',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'targa',
        text: 'Targa',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'telaio',
        text: 'Telaio',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'bpEmail',
        text: 'BP Utilizzatore',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'denominazioneEmail',
        text: 'Denominazione utilizzatore',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'email',
        text: 'Email utilizzatore',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'telefonoUtilizzatore',
        text: 'Cellulare utilizzatore',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'nrBpCliente',
        text: 'BP Cliente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'denominazioneCliente',
        text: 'Denominazione Cliente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'emailCliente',
        text: 'Email Cliente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'codiceVenditoreInterno',
        text: 'Codice Venditore',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'respClienteIndirizzoEmail',
        text: 'Responsabile Venditore indirizzo email',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'respClienteEmail',
        text: 'Responsabile Cliente/Venditore',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'rivenditoreEsterno',
        text: 'Rivenditore esterno',
        filter: {
          type: 'input',
        },
      },
    ];
  }

  private static getCustomColumnDaInviare(): CustomColumnModelInterface {
    return {
      name: 'btnDaInviare',
      index: 0,
      customButton: true,
      unsortable: true,
      condition: (element: GaragePassage) =>
        element.statoRecord !== 'INVIATO' && element.statoRecord !== 'ESCLUSO',
    };
  }

  private static getCustomColumnDaNonInviare(): CustomColumnModelInterface {
    return {
      name: 'btnDaNonInviare',
      index: 1,
      customButton: true,
      unsortable: true,
      condition: (element: GaragePassage) =>
        element.statoRecord !== 'INVIATO' && element.statoRecord !== 'ESCLUSO',
    };
  }

  private static getCustomColumnDetail(): CustomColumnModelInterface {
    return {
      name: 'btnDetail',
      index: 2,
      customButton: true,
      unsortable: true,
      condition: () => true,
    };
  }
}
